import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNER_REPORT } from "./apiRoutes";

interface UseGetOwnersReportProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnersReport = async (data: any) =>
  await axiosAuth.post(`${OWNER_REPORT}`, data);

const useGetOwnersReport = ({
  data,
  queryParams,
}: UseGetOwnersReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owners-report"],
    queryFn: () => getOwnersReport(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetOwnersReport;
